import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'
import { hotkey } from '#utilities/js/hotkey/hotkey.js'

const handler = object(null, {
  task (
    element,
    event
  ) {
    preventDefault(event)
    const { ownerDocument } = element
    const e = one(`input[name='act']`, ownerDocument)
    e.value = 'answer'
    globals.ea_form(e, '', null)
  }
})

export default (
  element
) => {
  hotkey(element, handler)
}